import React from "react";

import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";

import { Supplier } from "../../../../models/supplier";
import useStyles from "./styles";

interface SupplierDetailsProps {
  supplier?: Supplier;
}

const SupplierDetails = ({ supplier }: SupplierDetailsProps) => {
  const classes = useStyles();
  const { t: translate } = useTranslation();

  return (
    <Grid
      className={classes.supplierDetails}
      container
      direction="column"
      justifyContent="flex-start"
      spacing={2}
    >
      <Grid item>
        <h2>{translate("details")}</h2>
      </Grid>
      <Grid item container direction="row" justifyContent="flex-start" spacing={2}>
        <Grid item xs={6} md={3}>
          <h3>{translate("supplierCode")}</h3>
          <span>{supplier?.code}</span>
        </Grid>
        <Grid item xs={6} md={3}>
          <h3>{translate("email")}</h3>
          <span>{supplier?.email}</span>
        </Grid>
        <Grid item xs={6} md={3}>
          <h3>{translate("contactName")}</h3>
          <span>{supplier?.name}</span>
        </Grid>
      </Grid>
      <Grid item>
        <h2>{translate("address")}</h2>
      </Grid>
      <Grid item container direction="row" justifyContent="flex-start" spacing={2}>
        <Grid item xs={6} md={3}>
          <h3>{translate("address1")}</h3>
          <span>{supplier?.location?.addressLine1}</span>
        </Grid>
        <Grid item xs={6} md={3}>
          <h3>{translate("address2")}</h3>
          <span>{supplier?.location?.addressLine2}</span>
        </Grid>
        <Grid item xs={6} md={3}>
          <h3>{translate("streetNumber")}</h3>
          <span>{supplier?.location?.number}</span>
        </Grid>
        <Grid item xs={3}></Grid>
        <Grid item xs={6} md={3}>
          <h3>{translate("suburbTown")}</h3>
          <span>{supplier?.location?.suburb}</span>
        </Grid>
        <Grid item xs={6} md={3}>
          <h3>{translate("state")}</h3>
          <span>{supplier?.location?.state}</span>
        </Grid>
        <Grid item xs={6} md={3}>
          <h3>{translate("country")}</h3>
          <span>{supplier?.location?.country}</span>
        </Grid>
        <Grid item xs={6} md={3}>
          <h3>{translate("postalCode")}</h3>
          <span>{supplier?.location?.postalcode}</span>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default SupplierDetails;
